import { Accordion, Col, Container, Row } from "react-bootstrap";
import DetailItem from "./DataItem";
 
import userid from "../../../Assets/images/profile-managment/userid.svg"
import email from "../../../Assets/images/profile-managment/email.png"
import call from "../../../Assets/images/profile-managment/call.svg" 
import telephone from "../../../Assets/images/profile-managment/telephone.svg" 
const RequestorAccordion= ({sampleRequestDetails})=>{
return(
    // <Accordion className="accordion-item" defaultActiveKey="0" flush>
    <Accordion.Item eventKey="0">
        <Accordion.Header><b>Requestor Details</b></Accordion.Header>
        <Accordion.Body>
            <Container className="el-property-details-card-content">
                <Row>
                    <Col md={12} className="mx-fit-content">
                        <div className="flex-sec">
                            <DetailItem
                                iconSrc={userid}
                                title="Full Name"
                                detail={sampleRequestDetails?.requestor?.display_name || '-'}
                            />
                            <DetailItem
                                iconSrc={email}
                                title="Email Address"
                                detail={sampleRequestDetails?.requestor?.email || '-'}
                            />
                            <DetailItem
                                iconSrc={telephone}
                                title="Office Number"
                                detail={sampleRequestDetails?.requestor?.office_number || '-'}
                            />
                            <DetailItem
                                iconSrc={call}
                                title="Mobile Number"
                                detail={sampleRequestDetails?.requestor?.phone_number || '-'}
                            />
                            {/* <DetailItem
                                iconSrc="./images/profile-managment/department.svg"
                                title="Department Number"
                                detail="25"
                            />
                            <DetailItem
                                iconSrc="./images/profile-managment/role.svg"
                                title="Requesting Group"
                                detail="Immunology Biomarkers"
                            /> */}
                        </div>
                    </Col>
                </Row>
            </Container>
        </Accordion.Body>
    </Accordion.Item>
// </Accordion>
);
}

export default RequestorAccordion